import { Controller } from "@hotwired/stimulus"

// Copies an invite link to the clipboard.
//
// Fails safe, the same way confirm_controller does: the thing being copied is
// a readonly <input>, so with no JS -- bundle not loaded, clipboard permission
// refused, an insecure origin where navigator.clipboard does not exist -- it is
// still a field you can select and copy by hand. The button is an enhancement
// over that, never the only way through.
export default class extends Controller {
  static targets = ["source", "button"]

  async copy() {
    this.sourceTarget.select()

    try {
      await navigator.clipboard.writeText(this.sourceTarget.value)
      this.confirm("Copied")
    } catch {
      // Selected but not copied. Say which, rather than claiming a success
      // that would leave someone pasting the last thing they cut.
      this.confirm("Press ⌘C")
    }
  }

  confirm(message) {
    if (!this.hasButtonTarget) return

    const original = this.buttonTarget.dataset.label || this.buttonTarget.textContent
    this.buttonTarget.dataset.label = original
    this.buttonTarget.textContent = message
    clearTimeout(this.timer)
    this.timer = setTimeout(() => { this.buttonTarget.textContent = original }, 2000)
  }
}
